import { MergeMaps } from '../../../misc/helpers/map/merge';
export function GetRoutesPathParams(routesPath, path) {
    const params = new Map();
    for (let i = 0, l = routesPath.length; i < l; i++) {
        const route = routesPath[i];
        const result = route.pathMatcher.exec(path);
        if (result === null) {
            throw new Error(`The routePath doesn't match the path`);
        }
        else {
            MergeMaps(params, result.params);
            path = result.remaining;
        }
    }
    return params;
}
//# sourceMappingURL=get-routes-path-params.js.map